import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N3Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState("all");
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        const checkAdvancedSearchObject = JSON.stringify(advancedSearchText) === JSON.stringify({});
        if (checkAdvancedSearchObject) {
            navigate(`/search/n3/${textSearch ? encodeURIComponent(textSearch) : advancedSearchText}`);
        } else {
            const urlParams = new URLSearchParams(advancedSearchText).toString();
            navigate(`/search/n3/advanced?${urlParams}`);
        }
        setSubmitSearch(false);
    }, [textSearch, navigate, advancedSearch, advancedSearchText]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    const arrRules = [
        {
            title: "Alleles",
            value: "alleles",
        },
        {
            title: "Variation Type",
            value: "variation_type",
        },
    ];

    return (
        <MainLayout
            pathname="/search/n3"
            arrRules={arrRules}
            header="In-silico SNP Primer"
            exampleText={
                <div>
                    Examples - Gene:<span className="text-primary">GS3</span>, <span className="text-primary">GW5</span>, Alleles:
                    <span className="text-primary">G/T:0.11</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearch={setAdvancedSearch}
            advancedSearchText={advancedSearchText}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
